import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import TestRuns from './pages/TestRuns';
import TestRunDetail from './pages/TestRunDetail';
import HealthChecks from './pages/HealthChecks';
import Performance from './pages/Performance';
import Settings from './pages/Settings';
import TestRunner from './pages/TestRunner';
import MobileTestRunDetail from './pages/MobileTestRunDetail';
import JiraTickets from './pages/JiraTickets';
import TestCaseHistory from './pages/TestCaseHistory';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/test-runs" element={<TestRuns />} />
          <Route path="/test-runs/:id" element={<TestRunDetail />} />
          <Route path="/mobile-tests/:id" element={<MobileTestRunDetail />} />
          <Route path="/jira-tickets" element={<JiraTickets />} />
          <Route path="/test-case" element={<TestCaseHistory />} />
          <Route path="/health" element={<HealthChecks />} />
          <Route path="/performance" element={<Performance />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/test-runner" element={<TestRunner />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
